import { render, staticRenderFns } from "./FormSyInstructors.vue?vue&type=template&id=1bddae5b&scoped=true&"
import script from "./FormSyInstructors.vue?vue&type=script&lang=js&"
export * from "./FormSyInstructors.vue?vue&type=script&lang=js&"
import style0 from "./FormSyInstructors.vue?vue&type=style&index=0&id=1bddae5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bddae5b",
  null
  
)

export default component.exports